import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'aw-loading-elements',
    templateUrl: './loading-elements.component.html',
    styleUrls: ['./loading-elements.component.less']
})
export class LoadingElementsComponent implements OnInit {
  @Input() heading: string;
  constructor() { }

  ngOnInit() {
  }

}
